import React from 'react'
import styles from '../styles/Footer.module.scss'

export default function Footer() {
    return (
        <footer className={styles.footer}>
            © Videogames Store 2021 - Todos los derechos reservados
        </footer>
    )
}
